import { grey, lightGreen, red } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações das sustentações orais eletrônicas.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_SUSTENTACAO_ORAL_ELETRONICA = {
    SEM_VALIDACAO : { id: 'SEM_VALIDACAO', descricao: 'Não analisada', cor: grey[900]       },
    REPROVADA     : { id: 'REPROVADA',     descricao: 'Irregular',     cor: red[900]        },
    APROVADA      : { id: 'APROVADA',      descricao: 'Regular',       cor: lightGreen[900] },
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações das sustentações orais eletrônicas.
 * @readonly
 */
class SituacaoSustentacaoOralEletronica {
    /**
     * @private
     * @static
     */
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_SUSTENTACAO_ORAL_ELETRONICA);

    /**
     * Mensagem de erro para falha na identificação da situação da sustentação oral eletrônica.
     *
     * @public
     * @static
     */
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_SUSTENTACAO_ORAL_ELETRONICA =
        'Não foi possível identificar a situação da sustentação oral eletrônica.';

    /**
     * Retorna o ID da descrição da situação de sustentação oral eletrônica.
     *
     * @see {@link SituacaoIdDescricaoBase#getIdByDescricao}.
     */
    static getIdByDescricao(descricao) {
        return SituacaoSustentacaoOralEletronica.situacaoBase.getIdByDescricao(descricao);
    }

    /**
     * Retorna a descrição da situação de sustentação oral eletrônica correspondente ao ID.
     *
     * @see {@link SituacaoIdDescricaoBase#getDescricao}.
     */
    static getDescricao(id) {
        return SituacaoSustentacaoOralEletronica.situacaoBase.getDescricao(id);
    }

    /**
     * Retorna a cor da situação da sustentação oral eletrônica para textos e ícones.
     *
     * @param {string} id Identificador da situação de sustentação oral eletrônica.
     * @returns {string} O identificador de cor da situação de sustentação oral eletrônica correspondente ao ID.
     */
    static getCor(id) {
        return SituacaoSustentacaoOralEletronica.situacaoBase.getValorPropriedade(id, 'cor');
    }
}

export default SituacaoSustentacaoOralEletronica;
